import { Dropdown, IconButton, Modal, ResponsiveMode } from "@fluentui/react";
import React from "react";
import { ScrollableFormTree } from "../../../cpm/FormTree";
import { formatMessage } from "../../../../utils/helpers/LanguageHelper";
import { SourceTypeEnum } from "../../../../api/models/source-type-enum";
import useFormDropDown from "./FormDropDownHook";
import { FormTreeSelection } from "../../../cpm/FormTree";
import { DBApplication, FormTable } from "../../../interfaces/CoObject";

interface FormDropDownProps {
  form: FormTable | null;
  dbApplication: DBApplication | null;
  onFormClick: (selection: FormTreeSelection) => void;
  objectSource?: string;
  isComponentInstance?: boolean;
  isLocked?: boolean;
}

export const FormDropDown = (input: FormDropDownProps) => {
  const {
    form,
    onRenderCaretDown,
    setIsModalOpen,
    dbApplication,
    objectSource,
    isModalOpen,
    contentStyles,
    iconButtonStyles,
    cancelIcon,
    onFormClick,
    isComponentInstance,
    isLocked,
  } = useFormDropDown(input);

  return (
    <>
      <Dropdown
        id="form_dropdown"
        placeholder={form ? `${form.code} - ${form.desc}` : formatMessage("cof.base.select")}
        label={formatMessage("cof.createnewobject.form")}
        onRenderCaretDown={onRenderCaretDown}
        options={[]}
        onClick={() => !isComponentInstance && setIsModalOpen(true)}
        responsiveMode={ResponsiveMode.large}
        disabled={(dbApplication == null && objectSource !== SourceTypeEnum.EXCEL) || isComponentInstance || isLocked}
        required
      />
      {dbApplication ? (
        <Modal
          titleAriaId={"titleId"}
          isOpen={isModalOpen}
          onDismiss={() => setIsModalOpen(false)}
          isBlocking={false}
          containerClassName={contentStyles.container}
          styles={{
            main: {
              minHeight: "100%",
              minWidth: "100%",
            },
          }}
        >
          <div className={contentStyles.header}>
            <span id={"titleId"}>Form</span>
            <IconButton
              styles={iconButtonStyles}
              iconProps={cancelIcon}
              ariaLabel="Close popup modal"
              onClick={() => setIsModalOpen(false)}
            />
          </div>
          <div className={contentStyles.body}>
            <ScrollableFormTree
              onFormClick={onFormClick}
              dbId={dbApplication.id as string}
              oidPath={form ? form.oidPath : undefined}
            />
          </div>
        </Modal>
      ) : null}
    </>
  );
};
